import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// SEO: Redirect www to non-www (canonical domain)
if (typeof window !== 'undefined' && window.location.hostname === 'www.brovko.de') {
  window.location.replace('https://brovko.de' + window.location.pathname + window.location.search);
}

const rootElement = document.getElementById("root");
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
